import { Component, OnInit, OnDestroy } from "@angular/core";
import { ConfigService, ViewService, Item, ItemService } from "src/app/common";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "item-detail",
  templateUrl: "./item-detail.component.html",
  styleUrls: ["./item-detail.component.css"],
  standalone: false,
})
export class ItemDetail implements OnInit, OnDestroy {
  item: Item;
  subscriptions: any[];
  errorMsg: any;
  itemNumber: any;
  containerNumber: string;
  wasteTypeOptions: string[];

  constructor(
    public viewService: ViewService,
    private configService: ConfigService,
    private itemService: ItemService,
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];

    viewService.setViewData({ pageTitle: "Item Detail" });
  }

  ngOnInit(): void {
    this.configService.get().subscribe((appConfig) => {
      this.wasteTypeOptions = appConfig.wasteTypeOptions;
    });
    this.subscriptions.push(
      this.route.params.subscribe((params) => {
        this.itemNumber = params["itemId"];
        if (this.itemNumber) {
          this.itemService.get(this.itemNumber).subscribe((item) => {
            this.item = item;
            let editLink = item.canEdit
              ? { text: "» Edit", routeData: this.viewService.routerLink(["edit"]) }
              : undefined;
            this.viewService.setViewData({
              pageTitle: item.itemNumber,
              link: editLink,
            });
          });
        } else {
          setTimeout(() => {
            this.viewService.setViewData({ pageTitle: `Adding a new Item` });
          });
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }
}
